export type AppType = 'advon' | 'supermodel';

let cachedAppType: AppType | null = null;

/**
 * Detect the current app type from the document title
 */
export function detectAppType(): AppType {
  if (cachedAppType) {
    return cachedAppType;
  }

  // Check if we're in supermodel app by checking the document title or a global flag
  if (document.documentElement.getAttribute('data-app-type') === 'supermodel') {
    cachedAppType = 'supermodel';
    return cachedAppType;
  }

  // Default to advon
  cachedAppType = 'advon';
  return cachedAppType;
}

/**
 * Initialize the app type
 * @param appType - The app type
 */
export function initializeAppType(appType: AppType) {
  cachedAppType = appType;
  document.documentElement.setAttribute('data-app-type', appType);
}
